module.exports = __webpack_public_path__ + "img/ipad-en-11.f2aced0.jpg";